import { Link } from "gatsby"
import React, {useState, useEffect } from "react"
import Logo from '../components/Logo'
import MobileMenu from '../components/MobileMenu'
import {Button} from 'react-bootstrap'
import Menus from "./Menus"

const Header = () => {

  /*Mobile Menu*/
  const [mobile, setMobile] = useState({
    showMenu : false
  })

  const enableMobileMenu = () => {
    setMobile((prevState) => {
        return { ...prevState, showMenu : !prevState.showMenu};
       });
  }
  const hideMobileMenu = () => {
    setMobile((prevState) => {
        return { ...prevState, showMenu : false};
       });
  }


  const [header, setHeader] = useState({
    activeClass : ""
  });

  useEffect(() => {
    window.addEventListener('scroll', () => {
      let activeClass = '';
      if(window.scrollY > 50){
          activeClass = 'fixed';
      }
      setHeader((prevState) => {
       return { ...prevState, activeClass : activeClass};
      });
   });
  },[])

  return(
      <React.Fragment>
         <MobileMenu open={mobile.showMenu} close={hideMobileMenu}/>
         <header className={`header ${header.activeClass}`}>
          <nav className="navbar navbar-expand-lg fixed-top white-bg">
             <div className="container">
                <Link className="navbar-brand" to ="/">
                  <Logo />
                </Link>
                <Button onClick={() => enableMobileMenu()} className="mobileToggle">
                  <i className="ti-menu"></i>
                </Button>
                <ul className="navbar-nav ml-auto menu">
                  <Menus />
                </ul>
             </div>   
          </nav>
        </header>
      </React.Fragment>
  )
}


export default Header
